<template>
  <path
    d="M10.8 15.9002L15.47 12.4002C15.74 12.2002 15.74 11.8002 15.47 11.6002L10.8 8.10018C10.47 7.85018 10 8.09018 10 8.50018V15.5002C10 15.9102 10.47 16.1502 10.8 15.9002ZM12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 20.0002C7.59 20.0002 4 16.4102 4 12.0002C4 7.59018 7.59 4.00018 12 4.00018C16.41 4.00018 20 7.59018 20 12.0002C20 16.4102 16.41 20.0002 12 20.0002Z"
  />
</template>
